function loadCSS(href) {
    return new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
    });
}

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

function setupContextMenuDangerClass() {
    new MutationObserver(mutations => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType !== 1) continue;
                const menu = node.classList?.contains('tabulator-menu') ? node
                    : node.querySelector?.('.tabulator-menu');
                if (!menu) continue;
                const children = [...menu.children];
                const lastItem = children.findLast(el => el.classList.contains('tabulator-menu-item'));
                if (lastItem?.previousElementSibling?.classList.contains('tabulator-menu-separator')) {
                    lastItem.classList.add('danger');
                }
            }
        }
    }).observe(document.body, { childList: true, subtree: true });
}

export function loadTableAssets() {
    setupContextMenuDangerClass();
    return Promise.all([
        loadCSS('components/features/app-table/style/tabulator.css').then(() => loadCSS('style/tabulator.css')),
        loadScript('https://unpkg.com/tabulator-tables@6.2.0/dist/js/tabulator.min.js'),
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js')
    ]);
}
